import React from 'react';
import PropTypes from 'prop-types';

import './health-indicator.scss';

export default class ClassroomHealthIndicator extends React.Component {
  static propTypes = {
    strugglingPercentage: PropTypes.number,
    passingPercentage: PropTypes.number,
    excellingPercentage: PropTypes.number,
    emptyPercentage: PropTypes.number
  };

  getEmptyPercentage() {
    if (this.props.emptyPercentage) {
      return (
        <div
          className='health-indicator__health-empty'
          style={{width: `${this.props.emptyPercentage}%`}}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className='health-indicator'>
        <div
          className='health-indicator__health-struggling'
          style={{width: `${this.props.strugglingPercentage}%`}}
        />
        <div
          className='health-indicator__health-passing'
          style={{width: `${this.props.passingPercentage}%`}}
        />
        <div
          className='health-indicator__health-proficient-or-above'
          style={{width: `${this.props.excellingPercentage}%`}}
        />
        {this.getEmptyPercentage()}
      </div>
    );
  }
}
